import StatisticsPage from "@/views/statistics/StatisticsPage.vue";
export const statisticsRoutes = {
  path: "/statistics",
  component: StatisticsPage,
  name: "statisticsPage"
};
